/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';

export interface GoogleMarkProps {
  /** Edge length in pixels. Google's mark is square. */
  size?: number;
}

/**
 * Google's four-colour "G".
 *
 * The four colours are prescribed by Google's sign-in branding guidelines, so
 * they come from the --brand-google-* tokens rather than from our palette —
 * the same treatment the Facebook and WhatsApp marks already get.
 *
 * @param props - Optional edge length.
 * @returns The rendered mark.
 */
export const GoogleMark: React.FC<GoogleMarkProps> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    focusable="false"
    aria-hidden="true"
  >
    <path
      fill="var(--brand-google-blue)"
      d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62Z"
    />
    <path
      fill="var(--brand-google-green)"
      d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18Z"
    />
    <path
      fill="var(--brand-google-yellow)"
      d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33Z"
    />
    <path
      fill="var(--brand-google-red)"
      d="M9 3.58c1.32 0 2.5.46 3.44 1.35l2.58-2.58C13.46.9 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58Z"
    />
  </svg>
);
